<div class="accordion" id="frontline-community-{{device}}">
    <div class="border-bottom" *ngFor="let frontLineRow of frontLineData; let i=index">
        <div class="container-fluid">
            <div class="row py-3">
                <div class="col-12 d-flex align-items-center justify-content-between fl-collapse"
                    id="heading-{{device}}-{{frontLineRow.zip}}" data-toggle="collapse"
                    attr.data-target="#collapse-{{device}}-{{frontLineRow.zip}}" attr.aria-expanded="{{i == 0 ? true : false}}"
                    attr.aria-controls="collapse-{{device}}-{{frontLineRow.zip}}">
                    <div class="">
                        <div class="subtitle">{{frontLineRow.zip}} ({{frontLineRow.city.city}}, {{frontLineRow.state}})
                        </div>
                        <div class="footnote">NEAR {{frontLineRow.nearestZip}}</div>
                    </div>
                    <div class="btn-svg">
                        <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 9L9 1L1 9" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
            <div id="collapse-{{device}}-{{frontLineRow.zip}}" 
                [ngClass]="{'collapse ':true,'show ': i == 0 }"
                attr.aria-labelledby="heading-{{device}}-{{frontLineRow.zip}}"
                attr.data-parent="#frontline-community-{{device}}">
                <div class="m-4">
                    <div [ngClass]="{'row align-items-center justify-content-between py-3': true}">
                        <div class="col pr-lg-5">
                            <div class="text-xlarge"><b>{{frontLineRow.zip}} is likely to be a frontline community</b>
                                with
                                a
                                score of
                                {{frontLineRow.score}} out of
                                10.</div>
                            <div class="text-large pt-2 d-none d-md-block">We analyzed the following factors that are
                                known
                                to indicate social
                                vulnerability:
                            </div>
                        </div>
                        <div class="col-auto text-xlarge text-center px-md-5">
                            <div class="soi-number-container">
                                <span class=" soi-number">{{frontLineRow.score| number:'1.1-1'}}</span>
                            </div>
                        </div>
                        <div class="col-12 d-md-none pt-4">
                            <div class="text-large">We analyzed the following factors that are known to indicate social
                                vulnerability:
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center justify-content-between py-3 border-bottom">
                        <div class="col-8">
                            <div class="footnote text-uppercase">poverty level</div>
                            <div class="pt-2">
                                % of community below 200% of the national povery level
                            </div>
                        </div>
                        <div class="col-4 font-weight-normal h2 text-center">{{frontLineRow.poverty|
                            number:'1.0-0'}}%
                        </div>
                    </div>
                    <div class="row align-items-center justify-content-between py-3 border-bottom">
                        <div class="col-8">
                            <div class="footnote text-uppercase">Unemployment Rate</div>
                            <div class="pt-2">% of the community's total labor force that is estimated to be unemployed
                            </div>
                        </div>
                        <div class="col-4 font-weight-normal h2 text-center">{{frontLineRow.unemployment|
                            number:'1.0-0'}}%
                        </div>
                    </div>
                    <div class="row align-items-center justify-content-between py-3 border-bottom">
                        <div class="col-8">
                            <div class="footnote text-uppercase">BIPOC</div>
                            <div class="pt-2">% of community that is BIPoC
                            </div>
                        </div>
                        <div class="col-4 font-weight-normal h2 text-center">{{frontLineRow.bipoc|
                            number:'1.0-0'}}%
                        </div>
                    </div>
                    <div class="row align-items-center justify-content-between py-3 border-bottom">
                        <div class="col-8">
                            <div class="footnote text-uppercase">Disability</div>
                            <div class="pt-2">% of the community with a disability
                            </div>
                        </div>
                        <div class="col-4 font-weight-normal h2 text-center">{{frontLineRow.disability|
                            number:'1.0-0'}}%
                        </div>
                    </div>
                    <div class="row align-items-center justify-content-between py-3 border-bottom">
                        <div class="col-8">
                            <div class="footnote text-uppercase">Age Diversity</div>
                            <div class="pt-2">% of the community either younger than 17 or over 65
                            </div>
                        </div>
                        <div class="col-4 font-weight-normal h2 text-center">{{frontLineRow.under17over65|
                            number:'1.0-0'}}%
                        </div>
                    </div>
                    <div class="row align-items-center justify-content-between py-3 border-bottom">
                        <div class="col-8">
                            <div class="footnote text-uppercase">Limited English Proficiency</div>
                            <div class="pt-2">% of community with limited English proficiency
                            </div>
                        </div>
                        <div class="col-4 font-weight-normal h2 text-center">{{frontLineRow.limitedEnglish|
                            number:'1.0-0'}}%
                        </div>
                    </div>
                    <div class="row align-items-center justify-content-between py-3">
                        <div class="col-8">
                            <div class="footnote text-uppercase">Housing Burden</div>
                            <div class="pt-2">% of the community which is housing burdened, defined as spending 30% or more of their income on rent or a mortgage


                            </div>
                        </div>
                        <div class="col-4 font-weight-normal h2 text-center">
                            {{frontLineRow.houses|
                            number:'1.0-0'}}%
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
